<script lang="ts">
	import type { Navigation } from '$models/Navigation/Navigation';

	export let navigation: Navigation;
</script>

<details class="footer-widget footer-widget--accordion">
	<summary class="footer-title footer-toggle">{navigation.title}</summary>
	<div>
		<ul class="footer-menu">
			{#each navigation.items as item}
				<li class="footer-menu-item"><a href={item.url}>{item.title}</a></li>
			{/each}
		</ul>
	</div>
</details>

<style lang="postcss" global>
	.footer-widget {
		padding: 24px 0;
		position: relative;

		&::after {
			content: '';
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			height: 2px;
			background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5' height='2' viewBox='0 0 5 2'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23592e2c'/%3E%3C/svg%3E");
			background-size: 5px 2px;
			background-repeat: repeat-x;
			pointer-events: none;
		}

		&:first-child::before {
			content: '';
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			height: 2px;
			background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5' height='2' viewBox='0 0 5 2'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23592e2c'/%3E%3C/svg%3E");
			background-size: 5px 2px;
			background-repeat: repeat-x;
			pointer-events: none;
		}
	}

	.footer-title {
		color: var(--color-brown);
		font-size: 16px;
		font-family: var(--font-secondary);
	}

	.footer-menu-item {
		&:not(:last-child) {
			margin-bottom: var(--spacing-3);
		}

		a {
			display: block;
			font-size: 16px;
			text-decoration: none;
		}
	}

	@media (--lg) {
		.footer-widget {
			padding: 0;
			width: calc(100% / 3);

			&::after,
			&::before,
			&:first-child::before {
				display: none;
			}

			&--accordion {
				&::details-content {
					block-size: auto !important;
					content-visibility: visible !important;
				}

				.footer-toggle {
					pointer-events: none;
					cursor: default;
					padding-right: 0;
					margin-bottom: 8px;

					&:before,
					&:after {
						display: none;
					}
				}
			}
		}

		.footer-title {
			font-size: 20px;
		}

		.footer-menu-item a {
			font-size: 18px;
		}
	}

	@media (--xl) {
		.footer-widget {
			max-width: 220px;
			width: 100%;
		}
	}
</style>
